import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRouteLogin = ({ children }) => {
  const isLogin = localStorage.getItem("token");

  if (!isLogin) {
    return <Navigate to="/home" />;
  }

  return children;
};

export default ProtectedRouteLogin;
